import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Home from './components/Home';
import FilmProduction from './pages/FilmProduction';
import ShortMovies from './pages/ShortMovies';
import Academy from './pages/Academy';
import AdsMaking from './pages/AdsMaking';
import DigitalContent from './pages/DigitalContent';
import MusicProduction from './pages/MusicProduction';
import MovieDetail from './pages/MovieDetail';

// Admin Components
import Login from './admin/Login';
import ProtectedRoute from './admin/ProtectedRoute';
import Enquiries from './admin/Enquiries';
import Contacts from './admin/Contacts';
import PopupManager from './admin/PopupManager';
import BannerManager from './admin/BannerManager';
import ProjectManager from './admin/ProjectManager';
import CastManager from './admin/CastManager';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/film-production" element={<FilmProduction />} />
        <Route path="/short-movies" element={<ShortMovies />} />
        <Route path="/academy" element={<Academy />} />
        <Route path="/ads-making" element={<AdsMaking />} />
        <Route path="/digital-content" element={<DigitalContent />} />
        <Route path="/music-production" element={<MusicProduction />} />
        <Route path="/movie/:slug" element={<MovieDetail />} />

        {/* Admin Routes */}
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin" element={<Navigate to="/admin/enquiries" replace />} />
        <Route 
          path="/admin/enquiries" 
          element={
            <ProtectedRoute>
              <Enquiries />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/contacts" 
          element={
            <ProtectedRoute>
              <Contacts />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/popup" 
          element={
            <ProtectedRoute>
              <PopupManager />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/banners" 
          element={
            <ProtectedRoute>
              <BannerManager />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/projects" 
          element={
            <ProtectedRoute>
              <ProjectManager />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/cast" 
          element={
            <ProtectedRoute>
              <CastManager />
            </ProtectedRoute>
          } 
        />
        <Route path="/admin/dashboard" element={<Navigate to="/admin/enquiries" replace />} />
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{ zIndex: 99999, top: '20px' }}
      />
    </Router>
  );
}

export default App;

